<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="课程名称">
                <el-input style="width: 177px" v-model="queryForm.courseName"></el-input>
            </el-form-item>
            <el-form-item label="课程分类">
                <!--                <el-input  v-model="queryForm.categoryId"></el-input>-->
                <el-select
                    clearable
                    style="width: 177px"
                    v-model="queryForm.categoryId"
                    placeholder="请选择"
                    size="small"
                >
                    <el-tree
                        style="width: 177px"
                        :data="typeList"
                        :props="treeProps"
                        :render-after-expand="false"
                    >
                        <div
                            class="custom-tree-node flex items-center"
                            slot-scope="{ node, data }"
                        >
                            <el-option
                                :label="node.label"
                                :value="data.id"
                            > </el-option>
                        </div>
                    </el-tree>
                </el-select>
            </el-form-item>
            <el-form-item
                label="课程教师"
                prop="teacherId"
            >
                <GridSelectU style="width: 177px;" title="选择教师" labelName="teacherName"
                             labelValue="id" :value="queryForm.teacherId" :limit='1' size='small' placeholder='请选择教师'
                             @getValue="getSearchValueUser" :columns="TEACHER_code" :searchs="TEACHER_search" dataListUrl="/edu/teacher/findList" entityBeanName="eduTeacher" queryEntityUrl="/edu/teacher/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="上架状态">
                <!--                <el-input  v-model="queryForm.isShow"></el-input>-->
                <el-select
                    clearable
                    style="width: 177px"
                    v-model="queryForm.isShow"
                    placeholder="请选择"
                    size="small"
                >
                    <el-option
                        label="上架"
                        :value="1"
                    > </el-option>
                    <el-option
                        label="下架"
                        :value="0"
                    > </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addEduCourse"
                    >新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editEduCourse(null)"
                    >修改</el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteEduCourse(null)"
                    >删除</el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                      <Icon color="#606266">
                        <Search />
                      </Icon>
                    </span>
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportEduCourseList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span
                        class="icon-box"
                        @click="refreshEduCourseList"
                    >
                      <Icon color="#606266">
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="eduCourseList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="courseName"
                    label="课程名称"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="coursePic"
                    label="课程图片"
                    width="180"
                >
                    <template scope="scope">
                        <el-image
                            @click='updateSrcList(scope.row.coursePic)'
                            style='width: 80px; height: 80px'
                            :src='scope.row.coursePic'
                            :preview-src-list='srcList'
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="coursePrice"
                    label="课程价格"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="originalPrice"
                    label="程课原价"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="categoryId"
                    label="课程分类"
                    width="180"
                >
                    <template scope="scope">
                        <span>{{ scope.row.category ? scope.row.category.categoryName : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="courseType"
                    label="课程类型"
                    width="180"
                >
                    <template scope="scope">
                        <span>{{ courseTypeEnumList.find(e=>e.key == scope.row.courseType).value }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="teacherId"
                    label="课程教师"
                    width="180"
                >
                    <template scope="scope">
                        <span>{{ scope.row.teacher ? scope.row.teacher.teacherName : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="courseIntro"
                    label="课程简介"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="courseContent"
                    label="课程介绍"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="totalMinutes"
                    label="课程时长"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="startDate"
                    label="课程开始日期"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="endDate"
                    label="课程结束日期"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="isShow"
                    label="上架状态"
                    width="180"
                >
                    <template slot-scope="scop">
                        {{ scop.row.isShow == 1 ? '上架' : '下架' }}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="expireDay"
                    label="过期天数"
                    width="180"
                >
                    <template slot-scope="scop">
                        {{ scop.row.expireDay == 0 ? '永久' : scop.row.expireDay + '天' }}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="studyCount"
                    label="学习人数"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="virtualCount"
                    label="虚拟人数"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="commentCount"
                    label="评论数量"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="viewCount"
                    label="浏览数量"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="sort"
                    label="排序"
                    width="180"
                > </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="520"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="openShowDialog(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">章节管理</span>
                            </div>
                            <!--div @click="openStudyDialog(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">学习进度</span>
                            </div-->
                            <div @click="openStudentDialog(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">学员管理</span>
                            </div>
                            <div @click="openOrderDialog(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">课程订单</span>
                            </div>
                            <div @click="checkEduCourse(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editEduCourse(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteEduCourse(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="eduCourseStates[eduCourseState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="eduCourse"
                        ref="eduCourseForm"
                        :rules="rules"
                        label-width="90px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="课程名称"
                            prop="courseName"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="eduCourse.courseName"
                                :disabled="eduCourseState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="课程价格"
                            prop="coursePrice"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="eduCourse.coursePrice"
                                :disabled="eduCourseState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="程课原价"
                            prop="originalPrice"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="eduCourse.originalPrice"
                                :disabled="eduCourseState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="课程分类"
                            prop="categoryId"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                v-model="eduCourse.categoryId"-->
                            <!--                                :disabled="eduCourseState == 'check'"-->
                            <!--                            ></el-input>-->
                            <el-select
                                clearable
                                style="width: 177px"
                                v-model="eduCourse.categoryId"
                                :disabled="eduCourseState == 'check'"
                                placeholder="请选择"
                                size="small"
                            >
                                <el-tree
                                    :data="typeList"
                                    :props="treeProps"
                                    :render-after-expand="false"
                                >
                                    <div
                                        class="custom-tree-node flex items-center"
                                        slot-scope="{ node, data }"
                                    >
                                        <el-option
                                            :label="node.label"
                                            :value="data.id"
                                        > </el-option>
                                    </div>
                                </el-tree>
                            </el-select>
                        </el-form-item>
                        <!--                        <el-form-item-->
                        <!--                            label="课程类型"-->
                        <!--                            prop="courseType"-->
                        <!--                        >-->
                        <!--                            <el-input-->
                        <!--                                size="small"-->
                        <!--                                v-model="eduCourse.courseType"-->
                        <!--                                :disabled="eduCourseState == 'check'"-->
                        <!--                            ></el-input>-->
                        <!--                        </el-form-item>-->
                        <el-form-item
                            label="课程教师"
                            prop="teacherId"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                v-model="eduCourse.teacherId"-->
                            <!--                                :disabled="eduCourseState == 'check'"-->
                            <!--                            ></el-input>-->
                            <GridSelectU style="width: 177px;" title="选择教师" labelName="teacherName" :disabled="eduCourseState == 'check'"
                                         labelValue="id" :value="eduCourse.teacherId" :limit='1' size='small' placeholder='请选择教师'
                                         @getValue="getValueUser" :columns="TEACHER_code" :searchs="TEACHER_search" dataListUrl="/edu/teacher/findList" entityBeanName="eduTeacher" queryEntityUrl="/edu/teacher/get">
                            </GridSelectU>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="课程简介"-->
<!--                            prop="courseIntro"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 177px"-->
<!--                                v-model="eduCourse.courseIntro"-->
<!--                                :disabled="eduCourseState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="课程介绍"-->
<!--                            prop="courseContent"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 177px"-->
<!--                                v-model="eduCourse.courseContent"-->
<!--                                :disabled="eduCourseState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="课程时长"
                            prop="totalMinutes"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                placeholder="课程时长(s)"
                                v-model="eduCourse.totalMinutes"
                                :disabled="eduCourseState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="开始日期"
                            prop="startDate"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                v-model="eduCourse.startDate"-->
                            <!--                                :disabled="eduCourseState == 'check'"-->
                            <!--                            ></el-input>-->
                            <el-date-picker
                                v-model="eduCourse.startDate"
                                type="datetime"
                                :disabled="eduCourseState == 'check'"
                                style="width: 177px;"
                                placeholder="选择开始日期"
                                size="small"
                                format='yyyy-MM-dd HH:mm:ss'
                                value-format='yyyy-MM-dd HH:mm:ss'>
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item
                            label="结束日期"
                            prop="endDate"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                v-model="eduCourse.endDate"-->
                            <!--                                :disabled="eduCourseState == 'check'"-->
                            <!--                            ></el-input>-->
                            <el-date-picker
                                v-model="eduCourse.endDate"
                                :disabled="eduCourseState == 'check'"
                                type="datetime"
                                style="width: 177px;"
                                placeholder="选择结束日期"
                                size="small"
                                format='yyyy-MM-dd HH:mm:ss'
                                value-format='yyyy-MM-dd HH:mm:ss'>
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item
                            label="上架状态"
                            prop="isShow"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                v-model="eduCourse.isShow"-->
                            <!--                                :disabled="eduCourseState == 'check'"-->
                            <!--                            ></el-input>-->
                            <el-select
                                clearable
                                style="width: 177px"
                                v-model="eduCourse.isShow"
                                :disabled="eduCourseState == 'check'"
                                placeholder="请选择"
                                size="small"
                            >
                                <el-option
                                    label="上架"
                                    :value="1"
                                >
                                </el-option>
                                <el-option
                                    label="下架"
                                    :value="0"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="过期天数"
                            prop="expireDay"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                placeholder="有效期(天)"
                                v-model="eduCourse.expireDay"
                                :disabled="eduCourseState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="学习人数"
                            prop="studyCount"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="eduCourse.studyCount"
                                :disabled="eduCourseState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="虚拟人数"
                            prop="virtualCount"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="eduCourse.virtualCount"
                                :disabled="eduCourseState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="评论数量"
                            prop="commentCount"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="eduCourse.commentCount"
                                :disabled="eduCourseState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="浏览数量"
                            prop="viewCount"
                        >
                            <el-input
                                size="small"
                                style="width: 177px"
                                v-model="eduCourse.viewCount"
                                :disabled="eduCourseState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="排序"
                            prop="sort"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                v-model="eduCourse.sort"-->
                            <!--                                :disabled="eduCourseState == 'check'"-->
                            <!--                            ></el-input>-->
                            <el-input-number
                                style="width: 177px"
                                :disabled="eduCourseState == 'check'"
                                v-model="eduCourse.sort"
                                size="small"
                                label=""
                                :min="1"
                                :max="100000"
                                :step="1"
                                :controls="true"
                                controls-position="both"
                            >
                            </el-input-number>
                        </el-form-item>
                        <el-form-item
                            label="课程图片"
                            prop="coursePic"
                        >
                            <!--                            <el-input-->
                            <!--                                size="small"-->
                            <!--                                v-model="eduCourse.coursePic"-->
                            <!--                                :disabled="eduCourseState == 'check'"-->
                            <!--                            ></el-input>-->
                            <div style="width: 177px;;display: flex;align-items: center;">
                                <el-input v-model="eduCourse.coursePic" size="small" :disabled="eduCourseState == 'check'"></el-input>
                                <el-button type="primary" :disabled="eduCourseState == 'check'" size="small" style="margin-left: 2px;" @click="uploadImages()">上传图片
                                    <el-upload action="" v-show="false" ref="uploads" class="avatar-uploader" :show-file-list="false"
                                               :http-request="uploadAvatar">
                                        <el-button type="primary" size="small" class="as">上传</el-button>
                                    </el-upload>
                                </el-button>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="课程简介"
                            prop="courseIntro"
                        >
                            <el-input
                                size="small"
                                type="textarea"
                                :rows="3"
                                style="width: 39vw"
                                v-model="eduCourse.courseIntro"
                                :disabled="eduCourseState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="课程介绍"
                            prop="courseContent"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 39vw"-->
<!--                                type="textarea"-->
<!--                                :rows="3"-->
<!--                                v-model="eduCourse.courseContent"-->
<!--                                :disabled="eduCourseState == 'check'"-->
<!--                            ></el-input>-->
                            <div style="width: 39vw">
                                <WangEditor style="width: 100%;" :height="'150px'" ref="contentEditor" :disabled="eduCourseState" v-model="eduCourse.courseContent" />
                            </div>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="eduCourseState != 'check'"
                    >确定</el-button>
                </div>
            </el-dialog>

            <!--   课程章节   -->
            <el-drawer
                title="章节"
                :visible.sync="showCourse"
                direction="rtl"
                size="70%"
                :before-close="closeShowDialog">
                <EduCourseCharpter ref="merterial"></EduCourseCharpter>
            </el-drawer>
            <!--   课程订单   -->
            <el-drawer
                title="课程订单"
                :visible.sync="showOrder"
                direction="rtl"
                size="70%"
                :before-close="closeShowOrderDialog">
                <EduCourseOrder ref="order"></EduCourseOrder>
            </el-drawer>
            <!--   学员管理   -->
            <el-drawer
                title="学员管理"
                :visible.sync="showStudent"
                direction="rtl"
                size="70%"
                :before-close="closeShowStudentDialog">
                <EduCourseStudent ref="student"></EduCourseStudent>
            </el-drawer>

            <!--   学习进度   -->
            <el-drawer
                title="学习进度"
                :visible.sync="showStudyDialog"
                direction="rtl"
                size="70%"
                :before-close="closeStudyDialog">
                <EduCourseCharpterStudentrecord ref="students"></EduCourseCharpterStudentrecord>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { EDUTEACHER, EDUTEACHER_SEARCH } from '@/utils/constant';
import EduCourseCharpter from '@/components/edu/EduCourseCharpter.vue';
import EduCourseOrder from '@/components/edu/EduCourseOrder.vue';
import EduCourseStudent from '@/components/edu/EduCourseStudent.vue';
import EduCourseCharpterStudentrecord from '@/components/edu/EduCourseCharpterStudentrecord.vue';
import WangEditor from '@/components/common/wangeditor.vue';

export default {
    components: {
        WangEditor,
        EduCourseCharpterStudentrecord,
        EduCourseStudent,
        EduCourseOrder,
        EduCourseCharpter,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetEduCourseList();
                this.getEduCourseList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetEduCourseList();
                this.getEduCourseList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            courseTypeEnumList: [], //课程类型枚举
            typeList: [], //分类
            srcList: [''], //大图预览
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            showOrder: false,
            TEACHER_code: EDUTEACHER,
            TEACHER_search: EDUTEACHER_SEARCH,
            queryForm:{
                courseName: '', //课程名称
                coursePic: '', //课程图片
                coursePrice: '', //课程价格
                originalPrice: '', //程课原价
                categoryId: '', //课程分类
                courseType: 3, //课程类型1(点播)2(直播)3(下线)
                teacherId: '', //课程教师(课程里面会有多个)
                courseIntro: '', //课程简介
                courseContent: '', //课程介绍
                totalMinutes: '', //课程时长
                startDate: '', //课程开始日期
                endDate: '', //课程结束日期
                isShow: '', //上架状态：0下架 1上架
                expireDay: '', //过期天数（从购买后计算，0为永久不过期）
                studyCount: '', //学习人数
                virtualCount: '', //虚拟人数
                commentCount: '', //评论数量
                viewCount: '', //浏览数量
                sort: '', //排序
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            eduCourseState: 'add',
            eduCourseStates: {
                add: '新建线下课程',
                check: '查看线下课程',
                edit: '修改线下课程'
            },

            multipleSelection: [],
            eduCourseList: [],
            eduCourse: {
                courseName: '', //课程名称
                coursePic: '', //课程图片
                coursePrice: '', //课程价格
                originalPrice: '', //程课原价
                categoryId: '', //课程分类
                courseType: 3, //课程类型1(点播)2(直播)3(下线)
                teacherId: '', //课程教师(课程里面会有多个)
                courseIntro: '', //课程简介
                courseContent: '', //课程介绍
                totalMinutes: '', //课程时长
                startDate: '', //课程开始日期
                endDate: '', //课程结束日期
                isShow: '', //上架状态：0下架 1上架
                expireDay: '', //过期天数（从购买后计算，0为永久不过期）
                studyCount: 0, //学习人数
                virtualCount: 0, //虚拟人数
                commentCount: 0, //评论数量
                viewCount: 0, //浏览数量
                sort: 1, //排序
            },
            btnLoading: false,
            showCourse: false,
            rules: {
                courseName: [{ required: true, message: '课程名称不能为空', trigger: 'blur' }],
                coursePic: [{ required: true, message: '课程图片不能为空', trigger: 'blur' }],
                coursePrice: [{ required: true, message: '课程价格不能为空', trigger: 'blur' }],
                originalPrice: [{ required: true, message: '程课原价不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '课程分类不能为空', trigger: 'blur' }],
                courseType: [{ required: true, message: '课程类型不能为空', trigger: 'blur' }],
                teacherId: [{ required: true, message: '课程教师不能为空', trigger: 'blur' }],
                courseIntro: [{ required: true, message: '课程简介不能为空', trigger: 'blur' }],
                courseContent: [{ required: true, message: '课程介绍不能为空', trigger: 'blur' }],
                totalMinutes: [{ required: true, message: '课程时长不能为空', trigger: 'blur' }],
                startDate: [{ required: true, message: '课程开始日期不能为空', trigger: 'blur' }],
                endDate: [{ required: true, message: '课程结束日期不能为空', trigger: 'blur' }],
                isShow: [{ required: true, message: '上架状态不能为空', trigger: 'blur' }],
                expireDay: [{ required: true, message: '过期天数(单位:天,0为永久)', trigger: 'blur' }],
                studyCount: [{ required: true, message: '学习人数不能为空', trigger: 'blur' }],
                virtualCount: [{ required: true, message: '虚拟人数不能为空', trigger: 'blur' }],
                commentCount: [{ required: true, message: '评论数量不能为空', trigger: 'blur' }],
                viewCount: [{ required: true, message: '浏览数量不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
            },
            showStudent: false,
            showStudyDialog: false,
        };
    },
    created() {
        this.getEduCourseList();
        this.getCourseTypeEnum();
        this.gettypeList();
    },
    methods: {
        search(){
            this.isSearch = !this.isSearch;
        },
        openStudyDialog(id){
            this.showStudyDialog = true
            this.$nextTick(()=>{
                this.$refs.students.init(id)
            })
        },
        closeStudyDialog(){
            this.showStudyDialog = false
        },
        openStudentDialog(id){
            this.showStudent = true;
            this.$nextTick(()=>{
                this.$refs.student.init(id, 0)
            })
        },
        closeShowStudentDialog(){
            this.showStudent = false
        },
        closeShowOrderDialog(){
            this.showOrder = false;
        },
        openOrderDialog(id){
            this.showOrder = true;
            this.$nextTick(()=>{
                this.$refs.order.init(id)
            })
        },
        closeShowDialog(){
            this.showCourse = false
        },
        getSearchValueUser(value){
            this.queryForm.teacherId = value
        },
        openShowDialog(id){
            this.showCourse = true;
            this.$nextTick(()=>{
                this.$refs.merterial.init(id)
            })
        },
        uploadImages(){
            this.$refs.uploads.$el.querySelector(".as").click()
        },
        getValueUser(value) {
            this.eduCourse.teacherId = value
        },
        uploadAvatar(params) {
            console.log({ params });
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
                return;
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                console.log({ res });
                if (res.success) {
                    this.eduCourse.coursePic = res.url;
                }
            });
        },
        gettypeList(){
            get(`/edu/coursecategory/findAllAsTree`).then((res) => {
                if (res.success) {
                    this.typeList = res.treeData;
                }
            });
        },
        resetEduCourseList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.eduCourseList = [];
        },
        resetDialog() {
            this.eduCourseState = 'add';
            this.showDialog = false;
            this.queryForm = {
                courseName: '', //课程名称
                coursePic: '', //课程图片
                coursePrice: '', //课程价格
                originalPrice: '', //程课原价
                categoryId: '', //课程分类
                courseType: 3, //课程类型1(点播)2(直播)3(下线)
                teacherId: '', //课程教师(课程里面会有多个)
                courseIntro: '', //课程简介
                courseContent: '', //课程介绍
                totalMinutes: '', //课程时长
                startDate: '', //课程开始日期
                endDate: '', //课程结束日期
                isShow: '', //上架状态：0下架 1上架
                expireDay: '', //过期天数（从购买后计算，0为永久不过期）
                studyCount: '', //学习人数
                virtualCount: '', //虚拟人数
                commentCount: '', //评论数量
                viewCount: '', //浏览数量
                sort: '', //排序
            };
            this.getEduCourseList();
        },
        closeDialog() {
            this.showDialog = false
            this.eduCourse = {
                courseName: '', //课程名称
                coursePic: '', //课程图片
                coursePrice: '', //课程价格
                originalPrice: '', //程课原价
                categoryId: '', //课程分类
                courseType: 3, //课程类型1(点播)2(直播)3(下线)
                teacherId: '', //课程教师(课程里面会有多个)
                courseIntro: '', //课程简介
                courseContent: '', //课程介绍
                totalMinutes: '', //课程时长
                startDate: '', //课程开始日期
                endDate: '', //课程结束日期
                isShow: '', //上架状态：0下架 1上架
                expireDay: '', //过期天数（从购买后计算，0为永久不过期）
                studyCount: 0, //学习人数
                virtualCount: 0, //虚拟人数
                commentCount: 0, //评论数量
                viewCount: 0, //浏览数量
                sort: 1, //排序
            };
        },
        submitForm() {
            if (this.eduCourseState == 'add') {
                this.$refs.eduCourseForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/edu/course/add`,{ ...this.eduCourse }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetEduCourseList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.eduCourseState == 'edit') {
                this.$refs.eduCourseForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.eduCourse.teacher;
                        delete this.eduCourse.category;
                        post(`/edu/course/edit`,{ ...this.eduCourse }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addEduCourse() {
            this.showDialog = true;
            this.eduCourseState = 'add';
            this.$refs.contentEditor.htmls = ""
        },
        checkEduCourse(eduCourseId) {
            console.log(eduCourseId);
            this.currentEduCourseId = eduCourseId;

            this.getEduCourseById();
            this.showDialog = true;
            this.eduCourseState = 'check';
        },
        editEduCourse(eduCourseId) {
            console.log('eduCourse', eduCourseId);
            if (eduCourseId) {
                this.currentEduCourseId = eduCourseId;
                this.getEduCourseById();
            } else {
                this.eduCourse = { ...this.eduCourse, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.eduCourseState = 'edit';
        },
        deleteEduCourse(eduCourseId) {
            let ids = '';
            if (eduCourseId) {
                ids = eduCourseId;
            } else {
                ids = this.multipleSelection.map((eduCourse) => eduCourse.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/edu/course/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetEduCourseList();
                            this.getEduCourseList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshEduCourseList() {
            this.resetEduCourseList();
            this.getEduCourseList();
        },
        getEduCourseList(query = {}) {
            this.loading = true;
            get(`/edu/course/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.eduCourseList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getEduCourseById() {
            get(`/edu/course/get`,{ id: this.currentEduCourseId }).then((res) =>{
                if(res.success){
                    this.eduCourse = { ...this.eduCourse, ...res.eduCourse };
                    this.$refs.contentEditor.init(this.eduCourse.courseContent)
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportEduCourseList() {
            //this.btnLoading = true;
            exprotExcel(`/edu/course/export`, {...this.queryForm});
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/edu/course/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params){
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/edu/course/importData`,formData);
            this.refreshEduCourseList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getEduCourseList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getEduCourseList();
        },
        updateSrcList(src) {
            this.srcList[0] = src;
        },

        // 获取课程类型枚举
        getCourseTypeEnum(){
            get("/edu/utils/getEnum",{
                enumType: "course_type"
            }).then((res)=>{
                if(res.success){
                    this.courseTypeEnumList = res.enumList
                }
            })
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 177px;
    height: 177px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 177px;
    height: 177px;
    line-height: 177px;
    text-align: center;
}
.avatar {
    width: 177px;
    height: 177px;
    display: block;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>